import script from "./SignUpAutoForm.vue?vue&type=script&setup=true&lang=js"
export * from "./SignUpAutoForm.vue?vue&type=script&setup=true&lang=js"

import "./SignUpAutoForm.vue?vue&type=style&index=0&id=5e510467&lang=scss"

const __exports__ = script;

export default __exports__